import React from 'react';
import { Redirect } from 'react-router-dom';

const RedirectToQuestions = () => {
    return (
        <Redirect from="/platform" to="/platform/questions" />
    );
}

export default RedirectToQuestions;
